import type { RouteObject } from "react-router-dom";

export const returnLabelQuoteRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Return label quote" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { ReturnLabelQuotePage } =
            await import("./return-label-quote-page");
          return { Component: ReturnLabelQuotePage };
        },
      },
    ],
  },
];
